import styled from 'styled-components';

import { toRem, baseVariables } from '@marriott/mi-ui-library';

type StickyProps = {
  $isSticky: boolean;
  $offset: number;
  $top: number;
  $isClientSideView: boolean;
  $isGeneralMessageBannnerPresent: boolean;
  $isNorthStar: boolean;
};

export const StyledStickyComponentWrapper = styled.div<StickyProps>`
  ${(props: StickyProps) => {
    return !props.$isClientSideView
      ? `
      /* When isGeneralMessageBannnerPresent is true, the banner is rendered above the search form, and the top value is applied to account for the banner's height */
      
        top: ${props.$isGeneralMessageBannnerPresent ? toRem(131) : toRem(52)};
        position: absolute;
        
      /* Tablet: min-width 576px or higher depending on your breakpoint */
      @media (min-width: 576px) {
          top:  ${props.$isGeneralMessageBannnerPresent ? toRem(188) : toRem(88)};
          position: absolute;
      }
      /* Desktop: min-width 768px or higher depending on your breakpoint */
      @media (min-width: 768px) {
          top:  ${props.$isGeneralMessageBannnerPresent ? toRem(167) : toRem(88)};
          position: absolute;
      }
    `
      : `top: ${props.$isSticky ? toRem(props.$top) : toRem(props.$offset)};
     position: ${props.$isSticky ? 'fixed' : 'absolute'};`;
  }};
  width: 100vw;
  left: 0;
  ${({ $isSticky, $top }) => ($isSticky && $top !== 0 ? 'transition: top 0.4s ease 0s;' : '')}
  ${({ $isSticky }) => ($isSticky ? 'z-index: 50' : '')};

  [data-component-name='o-shop-searchform']:has(.search-form-wrapper) {
    ${({ $isSticky, $top, $isGeneralMessageBannnerPresent, $isNorthStar }) => {
      if ($isNorthStar) {
        return $isSticky
          ? `
           position: fixed;
          top: ${toRem($isGeneralMessageBannnerPresent ? $top + 131 : $top)};
  
          @media (min-width: 576px){ 
          top: ${toRem($isGeneralMessageBannnerPresent ? $top + 188 : $top)};
          }
  
          @media (min-width: 768px) {
          top: ${toRem($isGeneralMessageBannnerPresent ? $top + 167 : $top)};
        }
          `
          : `
          position: absolute;
          top: ${toRem(128)};
  
          @media ${baseVariables.mediaQuery.md} { 
           top: ${toRem(112)};
          }
           @media ${baseVariables.mediaQuery.lg} {
            top: ${toRem(140)};
           }
          `;
      }
      return '';
    }};
  }
`;
